import {differenceInYears, format, isValid, parse} from 'date-fns'
import { ptBR } from 'date-fns/locale';

export function diaDaSemana(value: Date) {
  const semana = ["DOMINGO", "SEGUNDA-FEIRA", "TERÇA-FEIRA", "QUARTA-FEIRA", "QUINTA-FEIRA", "SEXTA-FEIRA", "SÁBADO"];
  const dataAtual = new Date(value);
  const diaDaSemana = dataAtual.getDay();
  
  if (format(dataAtual, 'yyyy-mm-dd') === format(new Date(), 'yyyy-mm-dd')) {
      return 'HOJE';
  } else {
      return semana[diaDaSemana];
  }
}

export function transformDateLocaleToDateIso(date: string){
  const [dia, mes, ano] = date.split("/"); 
  const dataFormatada = new Date(`${ano}-${mes}-${dia}`).toISOString().split('T')[0];

  return dataFormatada;
}

export function calcularIdade(dataNascimentoStr: string): number {
  const dataNascimento = parse(dataNascimentoStr, 'dd/MM/yyyy', new Date(), { locale: ptBR })

  return differenceInYears(new Date(), dataNascimento)
}

export function isValidDate(dataStr: string) {
  const regex = /^\d{2}\/\d{2}\/\d{4}$/
  if (!regex.test(dataStr)) {
    return false
  }

  // Faz o parsing da data
  const data = parse(dataStr, 'dd/MM/yyyy', new Date())

  // Verifica se a data é válida e se os componentes batem com a string original
  const partes = dataStr.split('/')
  const dia = parseInt(partes[0], 10)
  const mes = parseInt(partes[1], 10)
  const ano = parseInt(partes[2], 10)

  return (
    isValid(data) &&
    data.getDate() === dia &&
    data.getMonth() + 1 === mes && // getMonth() é zero-based
    data.getFullYear() === ano
  )
}

export function isMaiorIdade(idade: number){
  return idade >= 14;
}